type DeliveryPricedUser = {
  customerNotes?: string;
  deliveryPrice?: number;
  deliveryPriceUpdatedFromWebsite?: boolean;
};

export const CUSTOMER_DELIVERY_PRICE_MIN = 0.01;
export const CUSTOMER_DELIVERY_PRICE_MAX = 1_000_000;

export const parseInvoiceAmountFromCustomerNotes = (
  notes?: string
): number | null => {
  if (!notes) return null;
  const match = notes.match(/\$(\d+(?:,\d{3})*(?:\.\d{2})?)/);
  if (!match || !match[1]) return null;
  const parsed = Number(match[1].replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
};

// Keep client previews aligned with the server without letting corrupt website-owned
// price records silently fall back to QuickBooks customer notes.
export const resolveCustomerDeliveryPrice = (
  user?: DeliveryPricedUser | null
): number | null => {
  if (user?.deliveryPriceUpdatedFromWebsite === true) {
    const websitePrice = user.deliveryPrice;
    if (
      typeof websitePrice !== "number" ||
      !Number.isFinite(websitePrice) ||
      websitePrice < CUSTOMER_DELIVERY_PRICE_MIN ||
      websitePrice > CUSTOMER_DELIVERY_PRICE_MAX
    ) {
      return null;
    }

    const cents = Math.round(websitePrice * 100);
    return Number.isSafeInteger(cents) && cents >= 1
      ? cents / 100
      : null;
  }

  return parseInvoiceAmountFromCustomerNotes(user?.customerNotes);
};

export const getCustomerDeliveryPriceErrorMessage = (
  user?: Pick<DeliveryPricedUser, "deliveryPriceUpdatedFromWebsite"> | null
) =>
  user?.deliveryPriceUpdatedFromWebsite === true
    ? "Website delivery price is missing or invalid"
    : "No valid delivery price was found in QuickBooks customer notes";